import { Injectable, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { normalizeLanguage, resolveLanguage, SupportedLanguage } from './supported-language';
import 'moment/locale/ru';

@Injectable({ providedIn: 'root' })
export class LanguageService implements OnDestroy {
  private readonly LANGUAGE_KEY = 'LANGUAGE';
  private languageSubscription?: Subscription;
  DEFAULT_LANGUAGE = resolveLanguage(null, this.translate.getBrowserLang());

  constructor(private translate: TranslateService) {
  }

  initialize(): void {
    const language = this.currentLanguage;
    localStorage.setItem(this.LANGUAGE_KEY, language);
    this.languageSubscription?.unsubscribe();
    this.languageSubscription = this.translate.onLangChange.subscribe(({ lang }) => {
      const selectedLanguage = normalizeLanguage(lang) || 'ru';
      moment.locale(selectedLanguage);
      localStorage.setItem(this.LANGUAGE_KEY, selectedLanguage);
    });
    this.translate.addLangs(['ru', 'en']);
    this.translate.setDefaultLang('ru');
    this.translate.use(language);
  }

  get currentLanguage(): SupportedLanguage {
    return resolveLanguage(localStorage.getItem(this.LANGUAGE_KEY), this.DEFAULT_LANGUAGE);
  }

  ngOnDestroy(): void {
    this.languageSubscription?.unsubscribe();
  }
}
